import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IssueTypes } from 'src/app/lib/shared/globals';

@Component({
  selector: 'app-select-issue-type',
  templateUrl: './select-issue-type.component.html',
  styleUrls: ['./select-issue-type.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectIssueTypeComponent),
      multi: true
    }
  ]
})
export class SelectIssueTypeComponent implements ControlValueAccessor, OnDestroy, OnInit {

  @Input() appearance: 'fill' | 'outline' | 'standard' = 'fill';
  @Input() label: string = 'Vorgangsart wählen';

  IssueTypes = Object.values(IssueTypes);

  valueControl: FormControl = new FormControl();

  private _subscriptions: Subscription[] = [];

  constructor() { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
  }

  public onTouched: () => void = () => { };
  registerOnTouched = (fn: any) => this.onTouched = fn;

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.valueControl.valueChanges.subscribe(fn));
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.valueControl.disable() : this.valueControl.enable();
  }

  writeValue = (val: any) => this.valueControl.patchValue(val);

}
